import { render, staticRenderFns } from "./FotoPendukungTipeBarang.vue?vue&type=template&id=09f4c31d&"
import script from "./FotoPendukungTipeBarang.vue?vue&type=script&lang=js&"
export * from "./FotoPendukungTipeBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports